import { css, CSSProp } from "styled-components";
import colors from "./colors";

const $screenXs = 320;
const $screenSm = 768;
const $screenMd = 992;
const $screenLg = 1200;

export default {
    mode: "dark" as "dark" | "light",
    c: { ...colors },
    xs: (style: CSSProp) => css`
        @media screen and (max-width: ${$screenSm - 1}px) {
            ${style}
        }
    `,
    sm: {
        only: (style: CSSProp) => css`
            @media screen and (min-width: ${$screenSm}px) and (max-width: ${$screenMd - 1}px) {
                ${style}
            }
        `,
        min: (style: CSSProp) => css`
            @media screen and (min-width: ${$screenSm}px) {
                ${style}
            }
        `,
        max: (style: CSSProp) => css`
            @media screen and (max-width: ${$screenMd - 1}px) {
                ${style}
            }
        `,
    },
    md: {
        only: (style: CSSProp) => css`
            @media screen and (min-width: ${$screenMd}px) and (max-width: ${$screenLg - 1}px) {
                ${style}
            }
        `,
        min: (style: CSSProp) => css`
            @media screen and (min-width: ${$screenMd}px) {
                ${style}
            }
        `,
        max: (style: CSSProp) => css`
            @media screen and (max-width: ${$screenLg - 1}px) {
                ${style}
            }
        `,
    },
    lg: (style: CSSProp) => css`
        @media screen and (min-width: ${$screenLg}px) {
            ${style}
        }
    `,
    withNotch: (style: CSSProp) =>
        // A browser that does not know env() drops the declaration on its own, so these
        // rules can go out unconditionally. The CSS.supports() test this replaced could
        // only be run in the browser, which left the server rendering every component
        // that uses withNotch without them - a class name mismatch on every hydration.
        style,
    $screenXs,
    $screenSm,
    $screenMd,
    $screenLg,

    $screenXsMax: $screenSm - 1,
    $screenSmMax: $screenMd - 1,
    $screenMdMax: $screenLg - 1,
};
